import { xCheck } from './xCheck';
/**
 * Computes the maximal value of an array of values
 *
 * @param array - array of numbers
 * @param options - options
 */
export function xMean(array, options = {}) {
    xCheck(array);
    const { fromIndex = 0, toIndex = array.length - 1 } = options;
    let sumValue = array[fromIndex];
    for (let i = fromIndex + 1; i <= toIndex; i++) {
        sumValue += array[i];
    }
    return sumValue / (toIndex - fromIndex + 1);
}
//# sourceMappingURL=xMean.js.map